import { createSlice } from "@reduxjs/toolkit";
import {
  GetAllClaimCommunications,
  GetAllClaimsList,
  GetAllClaimStatus,
  GetAllClaimType,
  GetAllHistoryLog,
  GetClaimCancelResponse,
  GetClaimEligibility,
  GetClaimPreauthorization,
  GetClaimRequest,
  GetClaimResponse,
  GetPrepareClaimService,
  ViewClaim,
  ViewClaimResponseHistoryLog,
} from "./cliamApi.js";
import { getToday } from "helpers/utils";

const CliamSlice = createSlice({
  name: "claim",
  initialState: {
    claimListData: [],
    cliamTypeList: [],
    claimSubTypeList: [],
    selectedDiagnosis: {},
    validationErrors: [],
    claimCoummunicationsList: [],
    claimNotes: [],
    viewModal: false,
    editModal: false,
    viewClaimInfo: null,
    viewClaimReq: null,
    claimStatisticsData: null,
    viewClaimRes: null,
    viewClaimCancelRes: null,
    claimResponseData: null,
    claimRequestData: null,
    prepareClaimsServices: [],
    excelData: [],
    validationExcelErrors: [],
    isExcelValid: false,
    selectedTableRow: [],
    historyModalOpen: false,
    claimHistoryLogData: [],
    selectedToothInfo: null,
    eligibilityData: null,
    claimCancelResponseData: null,
    claimPreauthResponseData: null,
    viewPreauthRes: null,
    viewEligibility: null,
    validationWarning: [],
    preauthorizationDiagnosis: [],
    cliamServicesList: [],
    selectedService: null,
    practitionerListAdded: [],
    claimStatusList: [],
    stepFormData: null,
    serviceSplits: {},
    claimFilters: {
      payer: "",
      insurance: "",
      patient: "",
      start_date: "",
      end_date: "",
      bundle_request_id: "",
      branch: "",
      cliam_status: "",
      claim_type: "",
      claimid: '',
      identity_type: "",
      claim_sub_type: "",
      second_response: "",
      specialities: "",
      doctors: "",
      communication: false,
    },
    prepareClaimFilters: {
      branch: "",
      claim_type: "",
      insurance: "",
      start_date: "",
      end_date: "",
    },
    paymentFilters: {
      payer: "",
      insurance: "",
      payment_number: "",
      claim_number: "",
      status: "",
      by_batch: true,
      by_received_date: false,
      start_date: "",
      end_date: "",
    },
  },
  reducers: {
    handleClaimFilter: (state, action) => {
      state.claimFilters[action?.payload?.check] = action?.payload?.value;
    },
    handlePrepareClaimFilter: (state, action) => {
      state.prepareClaimFilters[action?.payload?.check] =
        action?.payload?.value;
    },
    handlePaymentClaimFilter: (state, action) => {
      state.paymentFilters[action?.payload?.check] = action?.payload?.value;
    },
    handleFillStepData: (state, action) => {
      if (action?.payload?.check && action?.payload?.value !== undefined) {
        state.stepFormData = {
          ...state.stepFormData,
          [action.payload.check]: action.payload.value,
        };
      }
    },
    handleResetExcel: (state, _) => {
      state.validationExcelErrors = [];
      state.isExcelValid = false;
      state.excelData = [];
    },
    handleResetPrepareClaim: (state, _) => {
      state.prepareClaimFilters = {
        payer: "",
        insurance: "",
        start_date: "",
        end_date: "",
      };
    },
    setHistoryModal: (state, action) => {
      state.historyModalOpen = action?.payload;
    },
    setSelectedTableRow: (state, action) => {
      state.selectedTableRow = action.payload;
    },
    handleAddClaimNotes: (state, action) => {
      const { type, payload } = action.payload;
      if (type === "add") {
        state.claimNotes.push({
          id: Date.now(),
          ...payload,
        });
      } else if (type === "delete") {
        state.claimNotes = state.claimNotes.filter(
          (item) => item.id !== payload.id
        );
      }
    },
    setSelectedService: (state, action) => {
      state.selectedService = action.payload;
    },
    handleResetServiceSplit: (state, _) => {
      state.serviceSplits = {};
      state.prepareClaimsServices = [];
    },
    handleResetServices: (state, _) => {
      state.cliamServicesList = [];
    },
    resetSelectedService: (state) => {
      state.selectedService = null;
    },
    setViewModal: (state, action) => {
      state.viewModal = action.payload;
    },
    setEditModal: (state, action) => {
      state.editModal = action.payload;
    },
    handleSelectDiagnsosis: (state, action) => {
      state.selectedDiagnosis = state.preauthorizationDiagnosis?.find(
        (item) => item?.id === action?.payload
      );
    },
    setExcelData: (state, action) => {
      state.excelData = action.payload;
    },
    setValidationErrors: (state, action) => {
      state.validationErrors = action.payload;
    },
    setValidationExcelErrors: (state, action) => {
      state.validationExcelErrors = action.payload;
    },
    setIsExcelValid: (state, action) => {
      state.isExcelValid = action.payload;
    },
    handleResetFilter: (state, _) => {
      state.claimFilters = {
        payer: "",
        insurance: "",
        patient: "",
        start_date: "",
        end_date: "",
        bundle_request_id: "",
        claim_type: "",
        claim_sub_type: "",
        branch: "",
        cliam_status: "",
        claimid: "",
        specialities: "",
        second_response: "",
        identity_type: "",
        doctors: "",
        communication: false,
      };
    },
    addValidationError: (state, action) => {
      const exists = state.validationErrors.some(
        (error) => error.message === action.payload.message
      );
      if (!exists) {
        state.validationErrors.push(action.payload);
      }
    },
    addValidationWarning: (state, action) => {
      const exists = state.validationWarning.some(
        (error) =>
          error.message === action.payload.message &&
          error.code === action.payload.code
      );
      if (!exists) {
        state.validationWarning.push({
          code: action.payload.code,
          message: action.payload.message,
        });
      }
    },
    claimSelectedTooth: (state, action) => {
      state.selectedToothInfo = action.payload;
    },
    removeValidationWarningByCode: (state, action) => {
      state.validationWarning = state.validationWarning.filter(
        (warning) => warning.code !== action.payload
      );
    },
    clearValidationWarning: (state) => {
      state.validationWarning = [];
    },
    clearValidationErrors: (state) => {
      state.validationErrors = [];
    },
    handleAddPractitionerList: (state, action) => {
      const { type, payload } = action.payload;
      console.log({ payload });

      switch (type) {
        case "add":
          const exists = state.practitionerListAdded.some(
            (p) =>
              p.practitioner?.value?.practitioner_license ===
              payload.practitioner?.value?.practitioner_license
          );
          if (!exists) {
            state.practitionerListAdded.push({
              id:
                payload.practitioner?.value?.practitioner_license ||
                payload.id ||
                new Date().getTime(),
              practitioner: payload.practitioner || null,
              practice: payload.practice || null,
              role: payload.role || null,
              specialties: payload.specialties || [],
              originalSpecialties: payload.originalSpecialties || payload.specialties || [],
            });
          }
          break;
        case "addMultiple":
          payload.forEach((practitioner) => {
            state.practitionerListAdded.push({
              id: practitioner.id || new Date(),
              practitioner: practitioner.practitioner || null,
              practice: practitioner.practice || null,
              role: practitioner.role || null,
              specialties: practitioner.specialties || [],
              originalSpecialties:
                practitioner.originalSpecialties ||
                practitioner.specialties ||
                [],
            });
          });
          break;
        case "delete":
          if (payload?.id) {
            state.practitionerListAdded = state.practitionerListAdded.filter(
              (p) => p.practitioner?.value?.practitioner_license !== payload.id
            );
          }
          break;
        case "update":
          if (payload?.id) {
            const index = state.practitionerListAdded.findIndex(
              (p) => p.id === payload.id
            );
            if (index !== -1) {
              state.practitionerListAdded[index] = {
                ...state.practitionerListAdded[index],
                ...payload,
                specialties:
                  payload.specialties ||
                  state.practitionerListAdded[index].specialties,
              };
            }
          }
          break;
        case "updateField":
          if (payload?.id && payload?.field) {
            const rowIndex = state.practitionerListAdded.findIndex(
              (p) => p.id === payload.id
            );
            if (rowIndex !== -1) {
              state.practitionerListAdded[rowIndex] = {
                ...state.practitionerListAdded[rowIndex],
                [payload.field]: payload.value,
                ...(payload.field === "practitioner" && {
                  practice: null,
                  specialties: payload.value?.specialties || [],
                }),
              };
            }
          }
          break;
        case "updateSpecialties":
          if (payload?.id) {
            const rowIndex = state.practitionerListAdded.findIndex(
              (p) => p.id === payload.id
            );
            if (rowIndex !== -1) {
              state.practitionerListAdded[rowIndex].specialties =
                payload.specialties ||
                state.practitionerListAdded[rowIndex].originalSpecialties;
            }
          }
          break;
        case "clear":
          state.practitionerListAdded = [];
          break;
        default:
          console.warn("Unknown action type:", type);
          break;
      }
    },
    handleAddClaimServices: (state, action) => {
      const { type, payload } = action.payload;
      if (type === "ADD_SERVICES") {
        const isDuplicate = state.cliamServicesList.some(
          (service) => service.id === payload.id
        );

        if (!isDuplicate) {
          const newPeriod = payload.period
            ? { ...payload.period }
            : { start: getToday(), end: getToday() };
          state.cliamServicesList.push({
            id: payload?.id || Date.now(),
            ...payload,
            invoice_no: payload?.invoice_no || "",
            period: newPeriod,
            splits: [
              {
                id: `${payload.prd_code}-0`,
                quantity: Number(payload["approved-quantity"] || 0),
                patient_share: payload.prd_pshre || "0",
                invoice_no: payload.invoice_no || "",
                period: { ...newPeriod }, // Independent period
                rowNumber: 1,
                isSplit: false,
                remaining: 0,
                children: [],
              },
            ],
          });
          state.serviceSplits[payload.preauthfull_id] =
            state.serviceSplits[payload.preauthfull_id] || [];
          state.serviceSplits[payload.preauthfull_id].push({
            ...payload,
            id: payload.id || `${payload.prd_code}-${Date.now()}`,
            period: { ...newPeriod }, // Independent period
            serviceNumber:
              state.serviceSplits[payload.preauthfull_id].length + 1,
            splits: [
              {
                id: `${payload.prd_code}-0`,
                quantity: Number(payload["approved-quantity"] || 0),
                patient_share: payload.prd_pshre || "0",
                invoice_no: payload.invoice_no || "",
                period: { ...newPeriod }, // Independent period
                rowNumber: 1,
                isSplit: false,
                remaining: 0,
                children: [],
              },
            ],
          });
        }
      } else if (type === "EDIT_SERVICES") {
        const serviceIndex = state.cliamServicesList.findIndex(
          (s) => s.id === payload.id
        );
        if (serviceIndex !== -1) {
          const updatedService = {
            ...state.cliamServicesList[serviceIndex],
            ...payload,
            period: payload.period
              ? { ...payload.period }
              : { ...state.cliamServicesList[serviceIndex].period },
          };
          if (updatedService.splits?.length > 0) {
            updatedService.splits[0].invoice_no =
              payload.invoice_no || updatedService.splits[0].invoice_no;
            updatedService.splits[0].period = payload.period
              ? { ...payload.period }
              : { ...updatedService.splits[0].period };
          }
          state.cliamServicesList[serviceIndex] = updatedService;
        }
        Object.keys(state.serviceSplits).forEach((preauthfull_id) => {
          const services = state.serviceSplits[preauthfull_id];
          const splitIndex = services.findIndex((s) => s.id === payload.id);
          if (splitIndex !== -1) {
            const updatedSplitService = {
              ...state.serviceSplits[preauthfull_id][splitIndex],
              ...payload,
              period: payload.period
                ? { ...payload.period }
                : { ...state.serviceSplits[preauthfull_id][splitIndex].period },
            };
            if (updatedSplitService.splits?.length > 0) {
              updatedSplitService.splits[0].invoice_no =
                payload.invoice_no || updatedSplitService.splits[0].invoice_no;
              updatedSplitService.splits[0].period = payload.period
                ? { ...payload.period }
                : { ...updatedSplitService.splits[0].period };
            }
            state.serviceSplits[preauthfull_id][splitIndex] =
              updatedSplitService;
          }
        });
      } else if (type === "period") {
        const index = state.cliamServicesList.findIndex(
          (item) => item.id === payload.id
        );
        if (index !== -1) {
          const start =
            payload.period?.start ||
            state.cliamServicesList[index].period?.start ||
            getToday();
          const end = payload.period?.end || start;

          state.cliamServicesList[index] = {
            ...state.cliamServicesList[index],
            ...payload,
            period: { start, end },
          };
        }

        const serviceIndex = state.serviceSplits[
          payload.preauthfull_id
        ]?.findIndex((s) => s.id === payload.id);

        if (serviceIndex !== -1) {
          const start =
            payload.period?.start ||
            state.serviceSplits[payload.preauthfull_id][serviceIndex].period
              ?.start ||
            getToday();
          const end = payload.period?.end || start;

          state.serviceSplits[payload.preauthfull_id][serviceIndex] = {
            ...state.serviceSplits[payload.preauthfull_id][serviceIndex],
            ...payload,
            period: { start, end },
          };
        }
      } else if (type === "DELETE_SERVICES") {
        state.cliamServicesList = state.cliamServicesList.filter(
          (item) => item?.id !== payload?.id
        );
        if (state.serviceSplits[payload.preauthfull_id]) {
          state.serviceSplits[payload.preauthfull_id] = state.serviceSplits[
            payload.preauthfull_id
          ].filter((s) => s.id !== payload.id);
          if (state.serviceSplits[payload.preauthfull_id].length === 0) {
            delete state.serviceSplits[payload.preauthfull_id];
          }
        }
      } else if (type === "UPDATE_PREAUTH_REF_NO") {
        const { id, preauthorization_ref_no } = payload;

        // Update cliamServicesList
        const serviceIndex = state.cliamServicesList.findIndex(
          (item) => item.id === id
        );
        if (serviceIndex !== -1) {
          state.cliamServicesList[serviceIndex].preauthorization_ref_no =
            preauthorization_ref_no;

          if (state.cliamServicesList[serviceIndex].splits?.length > 0) {
            state.cliamServicesList[
              serviceIndex
            ].splits[0].preauthorization_ref_no = preauthorization_ref_no;
          }
        }

        // Update serviceSplits
        for (const preauthfull_id in state.serviceSplits) {
          const services = state.serviceSplits[preauthfull_id];
          const serviceIndex = services.findIndex((s) => s.id === id);

          if (serviceIndex !== -1) {
            state.serviceSplits[preauthfull_id][
              serviceIndex
            ].preauthorization_ref_no = preauthorization_ref_no;

            if (
              state.serviceSplits[preauthfull_id][serviceIndex].splits?.length >
              0
            ) {
              state.serviceSplits[preauthfull_id][
                serviceIndex
              ].splits[0].preauthorization_ref_no = preauthorization_ref_no;
            }
          }
        }
      } else if (type === "UPDATE_INVOICE_NO") {
        const { id, invoice_no } = payload;

        // Update cliamServicesList
        const serviceIndex = state.cliamServicesList.findIndex(
          (item) => item.id === id
        );
        if (serviceIndex !== -1) {
          state.cliamServicesList[serviceIndex].invoice_no = invoice_no;

          if (state.cliamServicesList[serviceIndex].splits?.length > 0) {
            state.cliamServicesList[serviceIndex].splits[0].invoice_no =
              invoice_no;
          }
        }

        // Update serviceSplits
        for (const preauthfull_id in state.serviceSplits) {
          const services = state.serviceSplits[preauthfull_id];
          const serviceIndex = services.findIndex((s) => s.id === id);
          if (serviceIndex !== -1) {
            state.serviceSplits[preauthfull_id][serviceIndex].invoice_no =
              invoice_no;

            if (
              state.serviceSplits[preauthfull_id][serviceIndex].splits?.length >
              0
            ) {
              state.serviceSplits[preauthfull_id][
                serviceIndex
              ].splits[0].invoice_no = invoice_no;
            }
          }
        }
      } else if (type === "UPDATE_PATIENT_SHARE") {
        const { id, patient_share } = payload;

        // Update cliamServicesList
        const serviceIndex = state.cliamServicesList.findIndex(
          (item) => item.id === id
        );
        if (serviceIndex !== -1) {
          state.cliamServicesList[serviceIndex].prd_pshre = patient_share;

          if (state.cliamServicesList[serviceIndex].splits?.length > 0) {
            state.cliamServicesList[serviceIndex].splits[0].patient_share =
              patient_share;
          }
        }

        // Update serviceSplits
        for (const preauthfull_id in state.serviceSplits) {
          const services = state.serviceSplits[preauthfull_id];
          const serviceIndex = services.findIndex((s) => s.id === id);
          if (serviceIndex !== -1) {
            state.serviceSplits[preauthfull_id][serviceIndex].prd_pshre =
              patient_share;

            if (
              state.serviceSplits[preauthfull_id][serviceIndex].splits?.length >
              0
            ) {
              state.serviceSplits[preauthfull_id][
                serviceIndex
              ].splits[0].patient_share = patient_share;
            }
          }
        }
      }
    },
    handleAddSplit: (state, action) => {
      const { preauthId, serviceIndex, split } = action.payload;
      if (!state.serviceSplits[preauthId]) {
        state.serviceSplits[preauthId] = [];
      }
      const service = state.serviceSplits[preauthId][serviceIndex];
      if (service) {
        const newSplit = {
          ...split,
          patient_share: split.patient_share || "0",
          period: split.period || {}, // Preserve empty period
        };
        service.splits.push(newSplit);
        const totalUsed = service.splits.reduce(
          (sum, s) => sum + Number(s.quantity || 0),
          0
        );
        const remainingQty =
          Number(service["approved-quantity"] || 0) - totalUsed;
        service.splits = service.splits.map((s, idx) => ({
          ...s,
          remaining: idx === service.splits.length - 1 ? remainingQty : 0,
          period: s.period || {}, // Preserve empty period
        }));
      }
    },
    handleRemoveSplit: (state, action) => {
      const { preauthId, serviceIndex, splitIndex } = action.payload;
      if (
        state.serviceSplits[preauthId] &&
        state.serviceSplits[preauthId][serviceIndex]
      ) {
        state.serviceSplits[preauthId][serviceIndex].splits.splice(
          splitIndex,
          1
        );
        const service = state.serviceSplits[preauthId][serviceIndex];
        const totalUsed = service.splits.reduce(
          (sum, s) => sum + Number(s.quantity || 0),
          0
        );
        const remainingQty =
          Number(service["approved-quantity"] || 0) - totalUsed;
        service.splits = service.splits.map((s, idx) => ({
          ...s,
          remaining: idx === service.splits.length - 1 ? remainingQty : 0,
          period: s.period || {}, // Preserve empty period
        }));
      }
    },
    handleUpdateSplit: (state, action) => {
      const { preauthId, serviceIndex, split } = action.payload;
      if (
        state.serviceSplits[preauthId] &&
        state.serviceSplits[preauthId][serviceIndex]
      ) {
        const service = state.serviceSplits[preauthId][serviceIndex];
        const splitIndex = service.splits.findIndex((s) => s.id === split.id);
        if (splitIndex !== -1) {
          service.splits[splitIndex] = {
            ...split,
            patient_share: split.patient_share || "0",
            period: split.period || {}, // Preserve empty period or update with new period
          };
          const totalUsed = service.splits.reduce(
            (sum, s) => sum + Number(s.quantity || 0),
            0
          );
          const remainingQty =
            Number(service["approved-quantity"] || 0) - totalUsed;
          service.splits = service.splits.map((s, idx) => ({
            ...s,
            remaining: idx === service.splits.length - 1 ? remainingQty : 0,
            period: s.period || {}, // Preserve empty period
          }));
        }
      }
    },
    handleResetClaimAll: (state, _) => {
      state.claimCancelResponseData = null;
      state.claimPreauthResponseData = null;
      state.viewClaimInfo = null;
      state.viewEligibility = null;
      state.viewClaimReq = null;
      state.viewClaimRes = null;
      state.viewPreauthRes = null;
      state.selectedToothInfo = null;
      state.claimRequestData = null;
      state.selectedTableRow = [];
      state.claimResponseData = null;
      state.claimHistoryLogData = [];
    },
    handlePreauthorizationDiagnosis: (state, action) => {
      const { type, payload } = action.payload;

      if (type === "add") {
        const isDuplicate = state.preauthorizationDiagnosis.some(
          (item) =>
            item.code === payload.code &&
            item.type === payload.type &&
            item.description?.toLowerCase() ===
            payload.description?.toLowerCase() &&
            item.preauthfull_id === payload.preauthfull_id &&
            item?.id === payload?.id
        );

        if (!isDuplicate) {
          state.preauthorizationDiagnosis.push({
            id: Date.now(),
            preauthfull_id: payload.preauthfull_id,
            date: payload.date,
            type: payload.type,
            code: payload.code,
            description: payload.description,
            condition_onset: payload.condition_onset,
            level: payload?.level,
            effective_from: payload?.effective_from,
            inactive: payload?.inactive,
            reactivated: payload?.reactivated,
            sex: payload?.sex,
            Stype: payload?.Stype,
            AgeL: payload?.AgeL,
            AgeH: payload?.AgeH,
            Atype: payload?.Atype,
            onAdmission: payload?.onAdmission,
            RDiag: payload?.RDiag,
            Morph_Code: payload?.Morph_Code,
            RTA_diag: payload?.RTA_diag,
            concept_change: payload?.concept_change,
            UnacceptPDx: payload?.UnacceptPDx,
          });
        }
      } else if (type === "update") {
        const { id, field, value } = payload;
        const index = state.preauthorizationDiagnosis.findIndex(
          (item) => item.id === id
        );
        if (index !== -1) {
          state.preauthorizationDiagnosis[index][field] = value;
        }
      } else if (type === "delete") {
        const { ids } = payload;

        if (Array.isArray(ids)) {
          state.preauthorizationDiagnosis =
            state.preauthorizationDiagnosis.filter(
              (item) => !ids.includes(item.id)
            );
        } else {
          const { id } = payload;
          state.preauthorizationDiagnosis =
            state.preauthorizationDiagnosis.filter((item) => item.id !== id);
        }
      }
    },
    handlePreauthFormData: (state, action) => {
      const { check, data, key, value } = action.payload;

      if (check === "save") {
        state.stepFormData = {
          ...state.stepFormData,
          ...data,
        };
      } else if (check === "edit") {
        state.stepFormData = {
          ...state.stepFormData,
          [key]: value,
        };
      } else if (check === "reset") {
        state.stepFormData = null;
      }
    },
    deleteClaimListRow: (state, action) => {
      const preauthId = action.payload.id;
      state.prepareClaimsServices = state.prepareClaimsServices.filter(
        (item) => item.preauthfull_id !== preauthId
      );
      if (state.serviceSplits[preauthId]) {
        delete state.serviceSplits[preauthId];
      }
      state.preauthorizationDiagnosis = state.preauthorizationDiagnosis.filter(
        (diag) => diag.preauthfull_id !== preauthId
      );
    },
    handleResetClaimHistoryLog: (state, _) => {
      state.claimHistoryLogData = [];
    },
    handleResetCreateClaim: (state, _) => {
      state.preauthorizationDiagnosis = [];
      state.cliamServicesList = [];
      state.claimNotes = [];
      state.historyModalOpen = false;
      state.selectedDiagnosis = null;
      state.practitionerListAdded = [];
      state.claimRequestData = null;
      state.claimCancelResponseData = null;
      state.claimHistoryLogData = [];
      state.claimNotes = [];
      state.claimPreauthResponseData = null;
      state.claimResponseData = null;
      state.editModal = false;
      state.selectedToothInfo = null;
      state.eligibilityData = null;
      state.selectedTableRow = [];
      state.selectedDiagnosis = null;
      state.validationErrors = null;
      state.viewClaimCancelRes = null;
      state.viewClaimInfo = null;
      state.viewClaimReq = null;
      state.viewClaimRes = null;
      state.viewEligibility = null;
      state.viewPreauthRes = null;
      state.stepFormData = null;
      state.serviceSplits = {};
      state.validationErrors = [];
      state.validationWarning = [];
    },
    deleteMultipleClaimListRows: (state, action) => {
      const preauthIds = action.payload.ids;

      state.prepareClaimsServices = state.prepareClaimsServices.filter(
        (item) => !preauthIds.includes(item.preauthfull_id)
      );

      preauthIds.forEach((id) => {
        if (state.serviceSplits[id]) {
          delete state.serviceSplits[id];
        }
      });

      state.preauthorizationDiagnosis = state.preauthorizationDiagnosis.filter(
        (diag) => !preauthIds.includes(diag.preauthfull_id)
      );
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(GetAllClaimStatus.fulfilled, (state, action) => {
        state.claimStatusList = action.payload?.data?.allstatus_data;
      })
      .addCase(GetAllClaimType.fulfilled, (state, action) => {
        state.cliamTypeList = action.payload?.data?.claim_type;
        state.claimSubTypeList = action.payload?.data?.claimsub_type;
      })
      .addCase(ViewClaim.fulfilled, (state, action) => {
        state.viewClaimInfo = action.payload?.data;
        state.viewEligibility = action.payload?.data?.eligibility_response_path;
        state.viewClaimReq = action.payload?.data?.claim_request_path;
        state.viewClaimRes = action.payload?.data?.claim_response_path;
        state.viewPreauthRes = action.payload?.data?.preauth_response_path;
        state.viewClaimCancelRes =
          action.payload?.data?.claim_cncl_response_path;
      })
      .addCase(GetClaimRequest.fulfilled, (state, action) => {
        state.claimRequestData = action.payload;
      })
      .addCase(GetClaimResponse.fulfilled, (state, action) => {
        state.claimResponseData = action.payload;
      })
      .addCase(GetClaimCancelResponse.fulfilled, (state, action) => {
        state.claimCancelResponseData = action.payload;
      })
      .addCase(GetAllHistoryLog.fulfilled, (state, action) => {
        state.claimHistoryLogData = action.payload?.data?.claim_histry;
      })
      .addCase(GetClaimEligibility.fulfilled, (state, action) => {
        state.eligibilityData = action.payload;
      })
      .addCase(GetClaimPreauthorization.fulfilled, (state, action) => {
        state.claimPreauthResponseData = action.payload;
      })
      .addCase(GetPrepareClaimService.fulfilled, (state, action) => {
        const preauthList = action?.payload?.data?.preauth_data || [];
        state.prepareClaimsServices = preauthList;

        preauthList.forEach((preauth) => {
          const preauthId = preauth?.preauthfull_id;
          if (!preauthId || state.serviceSplits[preauthId]) return;

          const rawItems = Array.isArray(preauth.item)
            ? preauth.item
            : Object.values(preauth.item || {});

          const validItems = rawItems.filter(
            (item) => item?.prd_code && item?.prd_code.trim() !== ""
          );

          if (validItems.length > 0) {
            state.serviceSplits[preauthId] = validItems.map((item, index) => ({
              ...item,
              id: item.prd_code || `${preauthId}-${index}`,
              serviceNumber: index + 1,
              split: item.split || false,
              period: item.period
                ? { ...item.period }
                : { start: getToday(), end: getToday() },
              splits: [
                {
                  id: `${item.prd_code}-0`,
                  quantity: Number(item["approved-quantity"] || 0),
                  patient_share: item.prd_pshre || "0",
                  invoice_no: item.invoice_no || "",
                  period: item.period
                    ? { ...item.period }
                    : { start: getToday(), end: getToday() },
                  rowNumber: 1,
                  isSplit: false,
                  remaining: 0,
                  children: [],
                },
                ...(item.split
                  ? [
                    {
                      id: `${item.prd_code}-1`,
                      quantity: Number(item["approved-quantity"] || 0),
                      patient_share: item.prd_pshre || "0",
                      invoice_no: item.invoice_no || "",
                      period: {}, // Initialize period as empty for new splits
                      rowNumber: 2,
                      isSplit: true,
                      remaining: 0,
                      children: [],
                    },
                  ]
                  : []),
              ],
            }));
          }
        });
      })
      .addCase(GetAllClaimCommunications.fulfilled, (state, action) => {
        state.claimCoummunicationsList =
          action?.payload?.data?.communication_details;
      })
      .addCase(ViewClaimResponseHistoryLog.fulfilled, (state, action) => {
        state.viewClaimInfo = action?.payload?.data;
      })
      .addCase(GetAllClaimsList.fulfilled, (state, action) => {
        state.claimListData = action.payload?.data?.claim_data;
        state.claimStatisticsData = action?.payload;
      });
  },
});

export const {
  handleClaimFilter,
  handleResetPrepareClaim,
  handlePrepareClaimFilter,
  handleResetCreateClaim,
  addValidationError,
  addValidationWarning,
  clearValidationWarning,
  handlePreauthFormData,
  handleAddPractitionerList,
  clearValidationErrors,
  setSelectedService,
  resetSelectedService,
  handleAddClaimNotes,
  setHistoryModal,
  handleResetClaimAll,
  deleteClaimListRow,
  handleFillStepData,
  claimSelectedTooth,
  setViewModal,
  setEditModal,
  setSelectedTableRow,
  setExcelData,
  setIsExcelValid,
  setValidationErrors,
  handleSelectDiagnsosis,
  handleResetExcel,
  setValidationExcelErrors,
  handleResetClaimHistoryLog,
  removeValidationWarningByCode,
  handleAddClaimServices,
  handlePaymentClaimFilter,
  handlePreauthorizationDiagnosis,
  deleteMultipleClaimListRows,
  handleResetServices,
  handleResetFilter,
  handleResetServiceSplit,
  handleAddSplit,
  handleRemoveSplit,
  handleUpdateSplit,
} = CliamSlice.actions;

export default CliamSlice.reducer;
